import {
	CONFIG_DATA_PENDING
	,CONFIG_DATA_FULFILLED
	,CONFIG_DATA_REJECTED
} from "./configTypes";

export const initialState = {
	fetching: false,
	fetched: false,
	data: null,
	error: null
};

export default function configReducer(state = initialState, action) {
	switch (action.type) {
		case CONFIG_DATA_PENDING:
			return {
				...initialState,
				fetching: true
			};
		case CONFIG_DATA_FULFILLED:
			return {
				...state,
				fetching: false,
				fetched: true,
				data: action.payload
			};
		case CONFIG_DATA_REJECTED:
			return {
				...initialState,
				fetching: false,
				fetched: false,
				error: action.payload
			};
		default:
			return state;
	}
};
